export default "<p>sectors works!</p>\n"